import { VaultObjectViewerModal } from "@/components/vault/viewer/VaultObjectViewerModal";
import { Flex } from "@radix-ui/themes";
import { Display } from "@/components/00-page-display/Display";

export default function HengeProjectPage() {
  return (
    <Flex
      direction={"column"}
      justify={"between"}
      align={"center"}
      className={"pt-36 h-full"}
    >
      <Display />

      <VaultObjectViewerModal />
    </Flex>
  );
}
